import React from 'react';
const Data = requests => ({
  getDataset: () => requests.get(`/data/dataset/all/`),
  delete: name => requests.delete(`/data/dataset/delete/${name}`),
  // submit: (name, liabilityClaim, citation, logo, mean, p02, p16, p50, p84, p98) => {
  submit: (name, liabilityClaim, citation, documentationLink, logo, mean, p02, p16, p50, p84, p98) => {
    const fd = new FormData();
    fd.append('name', name);
    fd.append('liabilityClaim', liabilityClaim);
    fd.append('citation', citation);
    fd.append('documentationLink', documentationLink);
    fd.append('logo', logo);
    fd.append('mean', mean);
    fd.append('p02', p02);
    fd.append('p16', p16);
    fd.append('p50', p50);
    fd.append('p84', p84);
    fd.append('p98', p98);

    return requests.post('/data/', fd);
  },
  updateDataset: values => requests.post('/data/update/', values),
  getMap: settings => requests.get(`/data/map/${settings}`),
  getNearestPoi: latlng => requests.get(`/data/curve/${latlng}`),
  exportCurves: datasetId => requests.download(`/data/curves/${datasetId}`),
  exportMaps: datasetId => requests.download(`/data/maps/${datasetId}`),
});

export default Data;



// WEBPACK FOOTER //
// ./src/agent/data.js